import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ReferenceDataProvider } from './context/ReferenceDataContext';
import { RequireAuth } from './components/RequireAuth';
import { LoginPage } from './pages/LoginPage';
import { GroupSetupForm } from './pages/GroupSetupForm';
import { SavedRequestsListPage } from './pages/SavedRequestsListPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <AuthProvider data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/login" element={<LoginPage data-id="element-4" />} data-id="element-3" />
          <Route path="/" element={<RequireAuth data-id="element-6">
                <SavedRequestsListPage data-id="element-7" />
              </RequireAuth>} data-id="element-5" />
          <Route path="/setup/:id" element={<RequireAuth data-id="element-9">
                <ReferenceDataProvider data-id="element-10">
                  <GroupSetupForm data-id="element-11" />
                </ReferenceDataProvider>
              </RequireAuth>} data-id="element-8" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-13" />} data-id="element-12" />
        </Routes>
      </AuthProvider>
    </BrowserRouter>;
}